import zggjdsjcyblh from '../../../assets/images/solution/network/zggjdsj.png'
import hzg20fhab from '../../../assets/images/solution/network/gzg20fhab.png'
import zggcddsjc from '../../../assets/images/solution/network/zggcddsjj.png'
import bjayhab from '../../../assets/images/solution/network/bjayhab.png'
import gzyyhab from '../../../assets/images/solution/network/gzyyhab.png'
import jxwzdejsjhlwfh from '../../../assets/images/solution/network/jxwz.png'
import njqahab from '../../../assets/images/solution/network/njqahab.png'
import shsjzggj from '../../../assets/images/solution/network/shsjzggj.png'
import bjdahab from '../../../assets/images/solution/network/bjdahab.png'
import ydylgjhzgfltab from '../../../assets/images/solution/network/ydylgjhzgfltab.png'
import hzyyhab from '../../../assets/images/solution/network/hzyyhab.png'
import cddyhab from '../../../assets/images/solution/network/cddyhab.png'

import commaUp from '../../../assets/images/solution/network/comma-up.png'
import commaDown from '../../../assets/images/solution/network/comma-down.png'

import styles from './style.module.scss'

function NetworkSafety() {
    return (
        <div className={`solution-introduction-wrapper ${styles['network-wrapper']}`}>
            <div className={`banner ${styles['banner']}`}>
                <div className='title'>网络安全</div>
                <div className='content'>通过各类感知设备搭载人工智能、大数据技术，打造多维感知、立体防控的智能感知系列解决方案</div>
            </div>
            <div className={`introduction-wrapper ${styles['introduction-wrapper']}`}>
                <p className='title'>方案简介</p>
                <div className={`introduction-title ${styles['introduction-title']}`}>
                    <div>
                        <img src={commaUp} alt="" />
                        <p>网络安全</p>
                        <p>烽火星空通过各类感知设备搭载人工智能、大数据技术，打造多维感知、立体防控的智能感知系列解决方案，全面提升网络安全治理能力，为基层执法人员的指挥调度、执法检查、活动安保等提供技术支撑。</p>
                        <img src={commaDown} alt="" />
                    </div>
                </div>
            </div>
            <div className={`achievement-wrapper ${styles['achievement-wrapper']}`}>
                <p className='title'>实践成果</p>
                <div className={`achievement-container ${styles['achievement-container']}`}>
                    <div className={styles['achievement-item']}>
                        <img src={ydylgjhzgfltab} alt="" />
                        <span>“一带一路”国际合作高峰论坛安保</span>
                    </div>
                    <div className={styles['achievement-item']}>
                        <img src={jxwzdejsjhlwfh} alt="" />
                        <span>世界互联网大会-乌镇峰会安保</span>
                    </div>
                    <div className={styles['achievement-item']}>
                        <img src={hzyyhab} alt="" />
                        <span>杭州亚运会安保</span>
                    </div>
                    <div className={styles['achievement-item']}>
                        <img src={cddyhab} alt="" />
                        <span>成都大运会安保</span>
                    </div>
                    <div className={styles['achievement-item']}>
                        <img src={zggcddsjc} alt="" />
                        <span>中国共产党第二十次全国代表大会安保</span>
                    </div>
                    <div className={styles['achievement-item']}>
                        <img src={bjdahab} alt="" />
                        <span>北京冬季奥运会安保</span>
                    </div>
                    <div className={styles['achievement-item']}>
                        <img src={shsjzggj} alt="" />
                        <span>中国国际进口博览会安保</span>
                    </div>
                    <div className={styles['achievement-item']}>
                        <img src={zggjdsjcyblh} alt="" />
                        <span>中国国际大数据产业博览会AI赋能</span>
                    </div>
                    <div className={styles['achievement-item']}>
                        <img src={hzg20fhab} alt="" />
                        <span>杭州G20峰会安保</span>
                    </div>
                    <div className={styles['achievement-item']}>
                        <img src={njqahab} alt="" />
                        <span>南京青奥会安保</span>
                    </div>
                    <div className={styles['achievement-item']}>
                        <img src={gzyyhab} alt="" />
                        <span>广州亚运会安保</span>
                    </div>
                    <div className={styles['achievement-item']}>
                        <img src={bjayhab} alt="" />
                        <span>北京奥运会安保</span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default NetworkSafety